import styled from "styled-components";

export const FooterWrapper = styled.div`
  padding: 16px 136px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  color: var(--GREY, #4a4a68);

  /* Caption */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 150% */
  letter-spacing: 0.36px;

  .footer-right {
    display: flex;
    gap: 24px;
    align-items: center;
    flex-wrap: wrap;

    span {
      display: inline-flex;
      align-items: center;
    }
  }
`;
